/*!
 * KoliBri - The accessible HTML-Standard
 */
var KolEvent;
(function (KolEvent) {
    KolEvent["blur"] = "blur";
    KolEvent["cancel"] = "cancel";
    KolEvent["change"] = "change";
    KolEvent["changeHeaderCells"] = "changeheadercells";
    KolEvent["changePage"] = "changepage";
    KolEvent["changePageSize"] = "changepagesize";
    KolEvent["click"] = "click";
    KolEvent["close"] = "close";
    KolEvent["create"] = "create";
    KolEvent["error"] = "error";
    KolEvent["focus"] = "focus";
    KolEvent["input"] = "input";
    KolEvent["keydown"] = "keydown";
    KolEvent["load"] = "load";
    KolEvent["mousedown"] = "mousedown";
    KolEvent["reset"] = "reset";
    KolEvent["select"] = "select";
    KolEvent["selectionChange"] = "selectionchange";
    KolEvent["sort"] = "sort";
    KolEvent["submit"] = "submit";
    KolEvent["toggle"] = "toggle";
})(KolEvent || (KolEvent = {}));
const DEFAULT_OPTIONS = {
    bubbles: true,
    cancelable: true,
    composed: true,
};
function createKoliBriEvent(event, detail = null) {
    return new CustomEvent(event, Object.assign(Object.assign({}, DEFAULT_OPTIONS), { detail }));
}
function dispatchDomEvent(target, event, detail) {
    return target.dispatchEvent(createKoliBriEvent(event, detail));
}

export { KolEvent as K, dispatchDomEvent as d };
//# sourceMappingURL=events-BhfZTW2e.js.map

//# sourceMappingURL=events-BhfZTW2e.js.map